import React, {useState} from 'react';

import PaginationAnything from '../pagination/PaginationAnything';
import Table from 'react-bootstrap/Table';
import { CGM_CODE_SET } from '../../../config/CgmCodeSet';


const openInNewTab = (url) => {
  var win = window.open(url, "", '_blank');
  win.focus();
}

const TableWithPagination = (props) => {
  const tableHeaderData = props.headerInfo;
  const tableBodyData = props.bodyInfo;
  const tableType = props.tableType;
  // const tableBodyLength = props.bodyLength;
  const tableBodyRowSize = props.tableRowSize;
  const pageLength = Math.ceil(props.bodyLength/props.tableRowSize);
  const tablePageWindowSize = props.tablePageWindowSize;

  const [activePage, setActivePage] = useState(1);

  let currentTableRow = (activePage-1) * tableBodyRowSize;

  const handleActivePage = (index) => {
    setActivePage(index);
  }

  const TableRow = (props) => {
    switch (tableType) {
      case "BuzzlistTable": {
        return (
          <tr>
            <td>
              {props.index}
            </td>
            <td>
              <span style={{cursor: "pointer"}} onClick={()=>openInNewTab(props.rowData.link)}>{props.rowData.title}</span>
            </td>
            <td>
              {CGM_CODE_SET[props.rowData.cgmcode]}
            </td>
            <td>
              {props.rowData.pubdate}
            </td>
          </tr>
        )
      }
      default: {
        break;
      }
    }
  }
  
  return(
    <div>
      <Table responsive>
        <thead>
          <tr>
            {tableHeaderData.map((item,index)=>(
              <th key={`table-header-${index}`}>
                {item}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {(tableBodyData.filter((item, index)=>(index >= currentTableRow) && (index < (currentTableRow + tableBodyRowSize)))).map((item,index)=>{
            // return(
            //   <BuzzlistTableRow key={`BuzzlistTableRow-${index}`} rowData={item} />
            // )
            return(
              <TableRow key={`table-body-row-${index}`} index={(activePage-1)*10+index+1} rowData={item._source} />
            )
          })}
        </tbody>
      </Table>
      <PaginationAnything windowSize={tablePageWindowSize} handleActivePage={handleActivePage} pageLength={pageLength} activePage={activePage} />
    </div>
  )
}

export default TableWithPagination;